export default "__VITE_ASSET__10009bc6__"